export function preventDefault(event) {
  event.preventDefault()
}
/** @public */
export const stopEventPropagation = (e) => e.stopPropagation()
